import { render, staticRenderFns } from "./SchoolBus3.vue?vue&type=template&id=5a87b67a&scoped=true&"
import script from "./SchoolBus3.vue?vue&type=script&lang=js&"
export * from "./SchoolBus3.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBus3.vue?vue&type=style&index=0&id=5a87b67a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87b67a",
  null
  
)

export default component.exports